import { Card } from "flowbite-react";
import React from "react";

interface MyAppProps {
  children: React.ReactNode;
  className?: string;
}

const CardBox: React.FC<MyAppProps> = ({ children, className }) => {
  return (
    <Card 
      className={`card border-[0.5px] border-[#F3F4F6] dark:border-[#F3F4F6] bg-white dark:bg-white ${className}`}
      theme={{
        root: {
          base: "flex bg-white dark:bg-white",
          children: "p-0"
        }
      }}
      style={{
        borderRadius: `6px`,
        boxShadow: 'none',
        backgroundColor: 'white'
      }}
    >
      {children}
    </Card>
  );
};

export default CardBox;